const c = {
  name: "IntegrationHelp",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M20,0C14.5,0,9.5,2.2,5.9,5.9C2.2,9.5,0,14.5,0,20c0,5.5,2.2,10.5,5.9,14.1C9.5,37.8,14.5,40,20,40
			c5.5,0,10.5-2.2,14.1-5.9C37.8,30.5,40,25.5,40,20c0-5.5-2.2-10.5-5.9-14.1C30.5,2.2,25.5,0,20,0z M19,2v4
			c-3.1,0.2-5.9,1.5-8.2,3.4L8,6.6C11,3.9,14.8,2.3,19,2z M21,6V2c4.2,0.2,8,1.9,11,4.6l-2.8,2.8C26.9,7.5,24.1,6.3,21,6z M2,19
			c0.2-4.2,1.9-8,4.6-11l2.8,2.8C7.5,13.1,6.3,15.9,6,19H2z M6,21c0.2,3.1,1.5,5.9,3.4,8.2L6.6,32C3.9,29,2.3,25.2,2,21H6z
			 M27.7,10.8l-3.6,3.6C23,13.5,21.6,13,20,13c-1.9,0-3.7,0.8-5,2.1c-1.3,1.3-2,3-2,4.9c0,1.6,0.5,3,1.4,4.2l-3.6,3.6
			C9.1,25.7,8,23,8,20c0-3.3,1.3-6.3,3.5-8.5C13.7,9.3,16.7,8,20,8C23,8,25.7,9.1,27.7,10.8z M12.3,29.2l3.6-3.6
			C17,26.5,18.4,27,20,27c1.9,0,3.7-0.8,5-2.1c1.3-1.3,2-3,2-4.9c0-1.6-0.5-3-1.4-4.2l3.6-3.6C30.9,14.3,32,17,32,20
			c0,3.3-1.3,6.3-3.5,8.5C26.3,30.7,23.3,32,20,32C17,32,14.3,30.9,12.3,29.2z M22.8,24.2C22,24.7,21,25,20,25
			c-1.4,0-2.6-0.6-3.5-1.5l0,0C15.6,22.6,15,21.4,15,20c0-1,0.3-2,0.8-2.8L22.8,24.2z M24.2,22.8l-6.9-6.9C18,15.3,19,15,20,15
			c1.4,0,2.6,0.6,3.5,1.5l0,0c0.9,0.9,1.5,2.1,1.5,3.5C25,21,24.7,22,24.2,22.8z M30.6,10.8L33.4,8c2.6,2.9,4.3,6.8,4.6,11h-4
			C33.7,15.9,32.5,13.1,30.6,10.8z M34,21h4c-0.2,4.2-1.9,8-4.6,11l-2.8-2.8C32.5,26.9,33.7,24.1,34,21z M29.2,30.6l2.8,2.8
			c-2.9,2.6-6.8,4.3-11,4.6v-4C24.1,33.7,26.9,32.5,29.2,30.6z M19,34v4c-4.2-0.2-8-1.9-11-4.6l2.8-2.8C13.1,32.5,15.9,33.7,19,34z"
			/>
	</g>
</g>
</svg>
  `
};
export {
  c as IntegrationHelp
};
